import { state, getters } from './state';
import { mutations } from './mutations';
export default {
  state,
  getters,
  mutations,
};
